var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 2.53125L2.84375 2.53125C2.41277 2.53125 1.99945 2.70245 1.6947 3.0072C1.38995 3.31195 1.21875 3.72527 1.21875 4.15625L1.21875 8.21875C1.21875 8.64973 1.38995 9.06305 1.6947 9.3678C1.99945 9.67254 2.41277 9.84375 2.84375 9.84375L7.3125 9.84375L9.75 11.4688V9.84375H10.1562C10.5872 9.84375 11.0006 9.67254 11.3053 9.3678C11.61 9.06305 11.7812 8.64973 11.7812 8.21875L11.7812 4.15625C11.7812 3.72527 11.61 3.31195 11.3053 3.0072C11.0006 2.70245 10.5872 2.53125 10.1562 2.53125Z",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 6.59375C4.0625 6.70149 4.0197 6.80483 3.94351 6.88101C3.86733 6.9572 3.76399 7 3.65625 7C3.54851 7 3.44517 6.9572 3.36899 6.88101C3.2928 6.80483 3.25 6.70149 3.25 6.59375C3.25 6.48601 3.2928 6.38267 3.36899 6.30649C3.44517 6.2303 3.54851 6.1875 3.65625 6.1875C3.76399 6.1875 3.86733 6.2303 3.94351 6.30649C4.0197 6.38267 4.0625 6.48601 4.0625 6.59375ZM6.5 6.59375C6.5 6.70149 6.4572 6.80483 6.38101 6.88101C6.30483 6.9572 6.20149 7 6.09375 7C5.98601 7 5.88267 6.9572 5.80649 6.88101C5.7303 6.80483 5.6875 6.70149 5.6875 6.59375C5.6875 6.48601 5.7303 6.38267 5.80649 6.30649C5.88267 6.2303 5.98601 6.1875 6.09375 6.1875C6.20149 6.1875 6.30483 6.2303 6.38101 6.30649C6.4572 6.38267 6.5 6.48601 6.5 6.59375ZM8.9375 6.59375C8.9375 6.70149 8.8947 6.80483 8.81851 6.88101C8.74233 6.9572 8.63899 7 8.53125 7C8.42351 7 8.32017 6.9572 8.24399 6.88101C8.1678 6.80483 8.125 6.70149 8.125 6.59375C8.125 6.48601 8.1678 6.38267 8.24399 6.30649C8.32017 6.2303 8.42351 6.1875 8.53125 6.1875C8.63899 6.1875 8.74233 6.2303 8.81851 6.30649C8.8947 6.38267 8.9375 6.48601 8.9375 6.59375Z",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWhite);
export default __webpack_public_path__ + "static/media/chatWhite.0650bd01aa8dea6f132d2ec13b73610b.svg";
export { ForwardRef as ReactComponent };